import {
  Conference,
  ConferenceKeys,
  ConferencePossibleStayPeriodKey,
  HotelReservationKeys,
  InviteeStatus,
  LocalDateTimeString,
  RegistrantData,
  RegistrantKeys,
} from 'ag-common-lib/public-api.functions';
import { RegistrantChairmanExtensionKeys } from 'ag-common-lib/lib/models/registration/registrant-chairman-extension';
import { ChairmanExtensionConfigurationKeys } from 'ag-common-lib/lib/models/registration/conference-chairman-extension';

export const isChairmanExtensionAccepted = (registrantData: RegistrantData, conference: Conference): boolean => {
  const isChairmanExtensionEnabled = conference?.[ConferenceKeys.isChairmanExtensionEnabled];
  const isApplicableForChairmanExtension = registrantData?.[RegistrantKeys.isApplicableForChairmanExtension];
  const chairmanExtensionInviteeStatus =
    registrantData?.[RegistrantKeys.chairmanExtension]?.[RegistrantChairmanExtensionKeys.inviteeStatus];

  return (
    isChairmanExtensionEnabled &&
    isApplicableForChairmanExtension &&
    chairmanExtensionInviteeStatus !== InviteeStatus.declined
  );
};

export const getChairmanExtensionStayDates = (
  registrantData: RegistrantData,
  conference: Conference,
): {
  [HotelReservationKeys.checkInDate]?: LocalDateTimeString;
  [HotelReservationKeys.checkOutDate]?: LocalDateTimeString;
} => {
  const registrationType = registrantData?.[RegistrantKeys.registrationType];
  const stayPeriods =
    conference?.[ConferenceKeys.chairmanExtensionConfiguration]?.[ChairmanExtensionConfigurationKeys.stayPeriods] ?? [];
  const scheduleRange = stayPeriods.find(
    range => range?.[ConferencePossibleStayPeriodKey.registrationType] === registrationType,
  );
  const arrivalDate =
    scheduleRange?.[ConferencePossibleStayPeriodKey.primaryArrivalDate] ?? conference?.[ConferenceKeys.startDate];
  const departureDate =
    scheduleRange?.[ConferencePossibleStayPeriodKey.primaryDepartureDate] ?? conference?.[ConferenceKeys.endDate];

  return {
    [HotelReservationKeys.checkInDate]: arrivalDate,
    [HotelReservationKeys.checkOutDate]: departureDate,
  };
};
